export class ProgramInfo {
  constructor(
  public programId: string = '',
  public programAbbreviation: string = '',
  public programDescription: string = '',
  public isActive: boolean = true,
  public disabled: boolean = false) {
  }
}
